import React from "react";
import { Alert, Box, Link, Typography } from "@mui/material";

/**
 * Orientação da API (listMetaPages): o que aconteceu, o que fazer e links da Meta.
 * @param {{ title?: string, summary?: string, steps?: { text: string }[], references?: { label: string, url: string }[] }} guidance
 */
export function MetaPagesGuidanceBlock({ guidance, requestId }) {
  if (!guidance || typeof guidance !== "object") return null;

  const steps = Array.isArray(guidance.steps) ? guidance.steps : [];
  const references = Array.isArray(guidance.references) ? guidance.references : [];

  return (
    <Alert severity="warning" sx={{ mt: 1, alignItems: "flex-start" }}>
      {guidance.title ? (
        <Typography variant="subtitle2" component="p" sx={{ mb: 0.75 }}>
          {guidance.title}
        </Typography>
      ) : null}
      {guidance.summary ? (
        <Typography variant="body2" component="p">
          {guidance.summary}
        </Typography>
      ) : null}

      {steps.length > 0 ? (
        <>
          <Typography variant="body2" component="p" sx={{ mt: 1.25, fontWeight: 600 }}>
            O que fazer
          </Typography>
          <Box
            component="ol"
            sx={{
              m: 0,
              mt: 0.75,
              pl: 2.25,
              "& li": { mb: 0.75 },
              "& li:last-of-type": { mb: 0 },
            }}
          >
            {steps.map((s, i) => (
              <Typography key={i} component="li" variant="body2">
                {s.text}
              </Typography>
            ))}
          </Box>
        </>
      ) : null}

      {references.length > 0 ? (
        <Box sx={{ mt: 1.25, display: "flex", flexDirection: "column", gap: 0.25 }}>
          {references.map((r, i) => (
            <Link key={i} href={r.url} target="_blank" rel="noreferrer" variant="body2">
              {r.label}
            </Link>
          ))}
        </Box>
      ) : null}

      {requestId ? (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1.25 }}>
          Se precisar de ajuda, informe este código: {requestId}
        </Typography>
      ) : null}
    </Alert>
  );
}
